import { createSelector } from 'reselect'

import { selectHydrated } from '../objects/selectors';

const getBrowserState = state => state.browser;
const getRange = state => state.browser.range || {};
export const locationProductType = (_, props) =>  props.location.state && props.location.state.productType;

export const getBrowserFilter = createSelector(
  getBrowserState,
  ({filter}) => filter
);

const selectAllItems = state => state.browser.items.map(i => selectHydrated(state, i))
export const selectItems = createSelector(
  selectAllItems,
  getBrowserFilter,
  (items, {min, max, district, types, term}) => {
    const t = Object.keys(types).filter(k => types[k]);

    items = items || [];

    if (t.length > 0 && t.length < 3) { // shortcut
      items = items.filter(obj => t.indexOf(obj.type) !== -1);
    }

    if (district) {
      items = items.filter(obj => String(obj.district.id) === district)
    }
    if (!min && !max) return items;
    return items.filter(object => 
      object.products.find(product =>
        product.monthlyEstimate > min && product.monthlyEstimate < max) )
  }
)

export const hasFilter = createSelector(
  getBrowserFilter,
  getRange,
  ({min, max, district, types, term}, {min: minRange, max: maxRange}) => {
    if (district !== '' || term !== '') {
      return true
    }

    if (Object.keys(types).filter(k => types[k]).length !== 3) {
      return true;
    }

    if ( (typeof min !== 'undefined' && min !== minRange) ||  (typeof max !== 'undefined' && max !== maxRange) ) {
      return true
    }

    return false;
  }
)

export const getId = (_, props) => {
  const id = props.match.params.id;
  return id && parseInt(id, 10);
}

export const getCenter = (state, props) => {
  const id = getId(state, props);
  if (id) {
    const item = selectHydrated(state, id);
    return item && {
      lat: item.lat,
      lng: item.lng
    }
  }
}





// WEBPACK FOOTER //
// ./src/redux/modules/browser/selectors.js